import { styled } from '@mui/material/styles'
import MuiTextField from '@mui/material/TextField'

const TextField = styled(MuiTextField)({
  width: '100%',
})

export default TextField
